module.exports = __webpack_public_path__ + "media/images/Implementation_Dashboard_Icon-5efabcdb.png";